import { createIcon } from '../createIcon';
import { ReactComponent as IconFileInvoice } from '../svg/file-invoice.svg';

export default createIcon(IconFileInvoice);
